<template>
  <button
    class="filter-item m-reset-button"
    type="button"
  >
    <BaseIcon
      :icon="icon"
    />
    <div class="filter-item-label">{{ label }}:</div>
    <span class="filter-item-right">
      <span class="filter-item-value">
        {{ value }}
      </span>
      <div class="filter-item-caret">
        <BaseIcon
          icon="arrowDown"
          :size="16"
        />
      </div>
    </span>
  </button>
</template>

<script setup>
import BaseIcon from '@/components/BaseIcon.vue';

defineProps({
  icon: {
    type: String,
    default: null,
  },
  label: {
    type: String,
    default: 'Label',
  },
  value: {
    type: String,
    default: '',
  },
});
</script>

<style scoped>
.filter-item {
  display: flex;
  gap: 4px;
  color: var(--gray-900);
}

.filter-item-label {

}

.filter-item-right {
  display: flex;
  gap: 4px;
  align-items: center;
}

.filter-item-value {
  font-weight: 700;
  text-decoration: underline;
}
</style>
